import axios from "axios";
import { useState } from "react";

import theme from "../styles/theme";
import Status from "../types/enum/Status";
import Button from "./Button";
import FlexBox, { FlexGrow } from "./FlexBox";
import Icon, { ClickableIcon } from "./Icon";
import Modal from "./Modal";
import { RightAlign } from "./UtilsComponents";

type TermDeleteModalProps = {
  isOpen?: boolean;
  setOpen: (x: boolean) => void;
  currentTerm: { [key: string]: any };
  // handleDeleteTerm: (regId: string) => void
  onDeleteComplete?: () => void;
  onDeleteError?: (err: any) => void;
};

const TermDeleteModal = ({
  isOpen,
  setOpen,
  currentTerm,
  // handleDeleteTerm,
  onDeleteError,
  onDeleteComplete,
}: TermDeleteModalProps): JSX.Element => {
  const [isOpenComplete, setOpenComplete] = useState<boolean>(false);
  const [isOpenError, setOpenError] = useState<boolean>(false);
  const [isLoading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);

  const handleDeleteTerm = async (regId: string) => {
    setLoading(true);
    axios
      .delete(`/api/v1/courses/terms/delete?term_id=${regId}`)
      .then((res) => {
        setOpenComplete(true);
      })
      .catch((err) => {
        setOpenError(true);
        console.error(err);
        setError(err);
      });
    // setOpen(false);
    setLoading(false);
  };

  const onComplete = () => {
    setOpenComplete(false);
    setOpen(false);
    onDeleteComplete?.();
  };

  const onError = () => {
    setOpen(false);
    setOpenError(false);
    onDeleteError?.(error);
  };

  return (
    <>
      <Modal isOpen={isOpen || false} setOpen={setOpen}>
        <FlexBox>
          <FlexGrow>
            <h3>Deleting Term</h3>
          </FlexGrow>
          <ClickableIcon name="x-s" onClick={() => setOpen(false)} />
        </FlexBox>
        <p>
          Are you sure you want to delete the term"
          <b>{currentTerm.name}</b>
          "? This cannot be undone.
        </p>
    
        <RightAlign style={{ marginTop: theme.spacing.x2 }}>
          <Button
            isOutline
            onClick={() => {
              setOpen(false);
            }}
            status={Status.default}
          >
            Cancel
          </Button>
          <Button
            style={{ marginLeft: 5 }}
            // disabled={isLoading || deletePasswordInput !== deletePassword}
            status={Status.primary}
            onClick={() => handleDeleteTerm(currentTerm.id)}
          >
            {isLoading && (
              <>
                <Icon mr={1} name="spinner" spin />
                Deleting...
              </>
            )}
            {!isLoading && (
              <>
                <Icon mr={1} name="trash" />
                Delete term
              </>
            )}
          </Button>
        </RightAlign>
      </Modal>

      <Modal
        isOpen={isOpenComplete}
        setOpen={setOpenComplete}
        onClose={onComplete}
        customStyle={{ content: { textAlign: "center" } }}
      >
        <img
          src="/alert-success-soft.svg"
          alt="alert warning"
          style={{ margin: "auto" }}
        />
        <h3>Term Deleting Complete</h3>
        <p>
          The term "<b>{currentTerm.name}</b>" has been
          removed.
        </p>
        <Button status={Status.primary} onClick={onComplete}>
          Done
        </Button>
      </Modal>

      <Modal
        isOpen={isOpenError}
        setOpen={setOpenError}
        onClose={onError}
        customStyle={{ content: { textAlign: "center" } }}
      >
        <img
          src="/alert-warning.svg"
          alt="alert warning"
          style={{ margin: "auto" }}
        />
        <h3>
          Term Delete Error<b> ({currentTerm.name})</b>
        </h3>
        <p>{error?.response?.data.error}</p>
        <Button status={Status.primary} onClick={onError}>
          Done
        </Button>
      </Modal>
    </>
  );
};

export default TermDeleteModal;
